import React from 'react'
import CreateStory from '../../Components/Story/CreateStory'


const Story = () => {
  return (
    <div>
      <CreateStory/>
    </div>
  );
};

export default Story;